import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ProjectUrl = `${Base_Url}/Project`;

export const GetProjectList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectUrl}/GetProjectList`,
    params
  );
  return res;
};

export const GetProjectReportList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectUrl}/GetProjectReportList`,
    params
  );
  return res;
};


export const AddUpdateProject = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectUrl}/AddUpdateProject`,
    params
  );
  return res;
};

export const GetProjectModel = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${ProjectUrl}/GetProjectModel?ProjectKeyID=${KeyID}`
  );
  return res;
};

export const GetProjectDocumentReport = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/ProjectDocument/GetProjectDocumentReport?ProjectKeyID=${KeyID}`
  );
  return res;
};

export const UpdateProjectStage = async (params) => {
  const res = await postApiWithAuthorization(
    `${ProjectUrl}/UpdateProjectStage`,
    params
  );
  return res;
};


export const ChangeProjectStatus = async (partiesKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/ChangeProjectStatus?ProjectKeyID=${partiesKeyID}`
  );
  return res;
};

// GetProjectLookupList

export const GetProjectLookupList = async (clientID) => {
  const { userKeyID } = JSON.parse(localStorage.getItem('login'))
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectLookupList?userKeyID=${userKeyID}&clientID=${clientID}`
  );
  return res;
};

export const GetAllProjectLookupList = async (clientID) => {
  const { userKeyID } = JSON.parse(localStorage.getItem('login'))
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectLookupList?userKeyID=${userKeyID}`
  );
  return res;
};

export const GetAllProjectLookupListWithoutUser = async (clientID) => {
  const { userKeyID } = JSON.parse(localStorage.getItem('login'))
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectLookupList?userKeyID=${userKeyID}`
  );
  return res;
};

export const GetAllProjectLookupListForReports = async (clientID) => {
  const { userKeyID } = JSON.parse(localStorage.getItem('login'))
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectLookupList?ClientID=${clientID}`
  );
  return res;
};

export const GetClientLookupList = async () => {
  const res = await getApiWithAuthorization(`${Base_Url}/Parties/GetClientLookupList`);
  return res;
};

export const GetClientTypeLookupList = async (ClientType) => {
  const res = await getApiWithAuthorization(`${Base_Url}/Parties/GetClientLookupList?ClientType=${ClientType}`);
  return res;
};


// UpdateJobStatus
export const UpdateStatusProject = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Project/ChangeProjcetStatusWithRemark`,
    params
  );


  return res;
};

export const getProjectDetails = async (ProjectKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectDetailsModel?ProjectKeyID=${ProjectKeyID}`
  );
  return res;
}